var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLyricsImageOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 25,
    viewBox: "0 0 44 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.5C2.5 4.29086 4.29086 2.5 6.5 2.5H17.5C19.7091 2.5 21.5 4.29086 21.5 6.5V17.5C21.5 19.7091 19.7091 21.5 17.5 21.5H6.5C4.29086 21.5 2.5 19.7091 2.5 17.5V6.5Z",
    stroke: "#656565",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.4999L5.8055 11.1945C6.68783 10.3122 8.15379 10.4443 8.86406 11.4702L10.7664 14.218C11.4311 15.1781 12.7735 15.3669 13.6773 14.6275L16.0992 12.646C16.8944 11.9954 18.0533 12.0532 18.7798 12.7797L21.5 15.4999",
    stroke: "#656565",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 7.5,
    r: 1.5,
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13L25.2929 12.2929L24.5858 13L25.2929 13.7071L26 13ZM35 14C35.5523 14 36 13.5523 36 13C36 12.4477 35.5523 12 35 12V13V14ZM30 9L29.2929 8.29289L25.2929 12.2929L26 13L26.7071 13.7071L30.7071 9.70711L30 9ZM26 13L25.2929 13.7071L29.2929 17.7071L30 17L30.7071 16.2929L26.7071 12.2929L26 13ZM26 13V14H35V13V12H26V13Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyricsImageOff);
export default __webpack_public_path__ + "static/media/lyrics-image-off.ccf3cc64284545e0bcd0177a6b66675a.svg";
export { ForwardRef as ReactComponent };